import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { IDocumentDTO, IDocumentWithBodyDTO, IMostPopularDocument, INameSpaceDTO, ISearchResponse } from '@typings/rootSlice';

export const adminApi = createApi({
    reducerPath: 'adminApi',
    tagTypes: ['Namespaces'],
    baseQuery: fetchBaseQuery({ baseUrl: `${__GATEWAY_URL__}/ads-news/api/public/v1` }),
    endpoints: (builder) => ({
        getNamespaces: builder.query<INameSpaceDTO[], void>({
            query: () => ({ url: '/namespace' }),
            providesTags: ['Namespaces'],
        }),
        getNamespace: builder.query<INameSpaceDTO, string>({
            query: (namespace) => ({ url: `/namespace/by_title/${namespace}` }),
        }),
        getDocuments: builder.query<Record<string, IDocumentDTO>, Record<string, number>>({
            query: ({ namespaceId, level }) => {
                const params = level ? `?level=${level}` : '';
                return { url: `/namespace/${namespaceId}/documents${params}` };
            },
        }),
        getDocumentTree: builder.query<Record<string, IDocumentDTO>, string>({
            query: (name) => ({ url: `/document/${name}/tree` }),
        }),
        getDocumentChildren: builder.query<IDocumentDTO[], string>({
            query: (name) => ({ url: `/document/${name}/children` }),
        }),
        getDocument: builder.query<IDocumentWithBodyDTO, number>({
            query: (id) => ({ url: `/document/${id}` }),
        }),
        searchDocuments: builder.query<ISearchResponse, { search: string; limit?: number; offset?: number }>({
            query: ({ search, limit = 10, offset = 0 }) => ({
                url: '/document',
                params: { search, limit, offset },
            }),
        }),
        getMostPopularDocuments: builder.query<IMostPopularDocument[], void>({
            query: () => ({ url: '/document/most_populars?limit=8&days_before=7' }),
        }),
    }),
});

export const {
    useGetNamespacesQuery,
    useLazyGetNamespacesQuery,
    useGetNamespaceQuery,
    useGetDocumentsQuery,
    useLazyGetDocumentsQuery,
    useGetDocumentTreeQuery,
    useGetDocumentChildrenQuery,
    useLazyGetDocumentChildrenQuery,
    useGetDocumentQuery,
    useLazySearchDocumentsQuery,
    useGetMostPopularDocumentsQuery,
} = adminApi;
